import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '发货人',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '电话',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'address',
        fieldName: '省市县',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'addressDetail',
        fieldName: '详细地址',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'defaultValue',
        fieldName: '是否默认',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        option: [{
          id: false,
          name: '否'
        }, {
          id: true,
          name: '是'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false,
          selectType: 3
        }
      }
    ]
  }
]
